<template>
    <a
        v-bind="$attrs"
        class="search-result-company"
        :data-bot="context ? `search-result__company--${context}` : 'search-result__company'"
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="company" />
        <div class="search-result-company__content">
            <div class="search-result-company__title">
                <h5
                    class="search-result-company__name typographies-paragraph-medium-bold"
                    v-html="name"
                />
                <TagThird :label="typeLabel" :type="type" size="extra-small" />
                <TagThird v-if="corpid" :label="getCorpId" type="reference" size="extra-small" />
            </div>
            <p
                v-if="address"
                class="search-result-company__address typographies-paragraph-medium-regular"
                v-html="address"
            />
            <div
                v-for="(extraField, index) in getHighlightedExtraFields"
                :key="index"
                class="typographies-paragraph-medium-regular search-result-company__extra-field"
            >
                <span> {{ extraField.label }}</span>
                <span v-html="extraField.value" />
            </div>
        </div>
    </a>
</template>
<script>
import SearchResultsGeneric from './SearchResultsGeneric.vue';
import TagThird from 'vcomponents/common/TagThird/TagThird.vue';

export default {
    components: {
        TagThird,
    },
    extends: SearchResultsGeneric,
    props: {
        address: {
            type: [String, Boolean],
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        corpid: {
            type: String,
            default: '',
        },
    },
    computed: {
        getCorpId() {
            return `Sellsy #${this.corpid}`;
        },
        typeLabel() {
            switch (this.type) {
                case 'client':
                    return this.$l10n.__('Client');
                case 'prospect':
                    return this.$l10n.__('Prospect');
                case 'supplier':
                    return this.$l10n.__('Fournisseur');
                default:
                    return '';
            }
        },
        classes() {
            return {
                'search-result-company--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-company {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__title {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);

        & + .search-result-company__extra-field {
            margin: var(--spacing-0) 0 0;
        }
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__address {
        color: var(--colors-common-text-subtle-default, #565665);
        margin: var(--spacing-0) 0 0;
    }

    :deep(.highlight) {
        background: var(--colors-common-background-highlight-search);
    }

    &__extra-field {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-0);
        padding: var(--spacing-0) 0 0;
    }

    &__corp-id {
        background: var(--colors-component-background-information-tag-grey, #e9e9ec);
        border-radius: 44px;
        color: var(--colors-common-text-primary-default, #4868fd);
        display: flex;
        padding: 0 var(--spacing-1);
    }
}
</style>
